import { graphql } from 'react-relay/legacy';

/**
 * Added item to initial query to be able to pull
 * handlePdpStatuses_item on server to determine if we need to redirect or 404.
 * Do not add other fragments to item in this query
 */

export const pdpRespCondensedRootQuery = graphql`
    query pdpRespCondensedRootQuery(
        $isClient: Boolean!
        $itemId: String!
        $itemIds: [String]!
        $userId: String = ""
        $userIds: [String]
        $fetchUser: Boolean!
        $fetchPdp: Boolean!
        $isTrade: Boolean!
        $isMultiSku: Boolean = false
        $followSearchPages: [String]
        $fetchFollowSearch: Boolean!
        $forcedCurrency: Currency
        $userCountryCode: String = ""
        $priceBookName: String = ""
        $localRecentHistoryItemIds: [String] = []
        $fetchUserRecentHistoryItem: Boolean = false
        $isInteractivePdpChat: Boolean = false
        $fetchRegionalInfo: Boolean = false
        $userZipCode: String!
        $fetchAuction: Boolean = false
        $isCondensedPdpRedesignVariant: Boolean = false
    ) {
        viewer {
            ...PdpRespCondensedLayout_viewer
            itemRead(itemIds: $itemIds) {
                ... on Item {
                    ...handlePdpStatuses_item
                }
                ...findPdpItemReadError_itemRead
            }
        }
    }
`;

export const pdpRespCondensedVariables = {
    isClient: false,
    itemId: null,
    itemIds: [],
    selectedItemIds: [],
    userId: '',
    userIds: [],
    fetchUser: false,
    loadPortfolioData: false,
    followSearchPages: null,
    fetchFollowSearch: false,
    isTrade: false,
    isMultiSku: false,
    fetchPdp: true,
    forcedCurrency: null,
};
